// extracted by mini-css-extract-plugin
module.exports = {"titleAccordion":"Accordion_titleAccordion__3P9vz","mobileMenu":"Accordion_mobileMenu__2V3jS"};